module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-copy"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('h1', [_vm._v("1616 SE 8th Street"), _c('br'), _vm._v("\n        Fort Lauderdale Florida 33316"), _c('br'), _vm._v("\n        954-300-4445"), _c('br'), _vm._v("\n        corp@opencabana.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1be02de2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/contact.vue
// module id = 591
// module chunks = 2